import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../../components/general/pageHeader/pageHeader";
import HeaderFoldersImage from "../../assets/img/Head-Fascicoli.svg";
import FoldersList from "../../components/folders/list";
import { getFolders, deleteFolder } from "../../store/actions/folders";
import { useIntl, FormattedMessage } from "react-intl";
import { usePermissions } from "../../customHooks";
import Page from "../../components/general/page";
import PageOverlay from "../../components/general/pageOverlay";
import { overflowNotificationConstants } from "../../store/actions/overflowNotification";

const FoldersView = props => {
  const {    
    pageRef
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  /** EVITA DI DOVER USARE LA CONNECT PERFORMANCE TOP */
  const company = useSelector(state => state.company);
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const user = useSelector(state => state.user);
  const foldersDetail = useSelector(state => state.foldersDetail);
  const usersList = useSelector(state => state.usersList);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const [isOwner, setIsOwner] = useState(false);

  const intl = useIntl();

  const foldersTitle = useIntl()
    .formatMessage({ id: "folders.title" })
    .toUpperCase();

  const foldersTitleCompany = useIntl()
    .formatMessage({ id: "folders.titleCompany" })
    .toUpperCase();

  useEffect(() => {
    const roles = user.roles;
    const isOwnerResources = roles.filter(resource =>
      resource.actionKey === "OWNER" &&
        (resource.appId === "DBX" || resource.appId === null));
    const currentStudio = isOwnerResources.filter(res => res.resourceId === main.accountantIdSelected);
    if (currentStudio.length > 0) {
      setIsOwner(true);
    }
  }, [user, usersList]);

  const { isPermissionCreateFolders } = usePermissions(
    currentPermissions,
    null,
    isOwner
  );

  const selectedCompanyName = company?.companies?.find(el => el.id === main.clientIdSelected);

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if (auth)
      dispatch(getFolders());
  }, []);

  const onNewClick = () => {
    navigate("/folders-edit");
  };

  const confirmDelete = folderId => {
    dispatch(deleteFolder(folderId))
      .then((res) => {
        dispatch({
          type: overflowNotificationConstants.SHOW_OVERFLOW,
          payload: {
            type: "success",
            title: "OK",
            message: intl.formatMessage({id: "folders.feedback.delete.ok"})
          }
        });
      });
  };

  const title =
    main.myType === "STUDIO" ? (
      <>
        <FormattedMessage id="folders.header.titleFirstPart" />{" "}
        <b>
          <FormattedMessage id="folders.header.boldTitle" />
        </b>{" "}
        <FormattedMessage id="folders.header.titleSecondPart" />
      </>
    ) : (
      <>
        <FormattedMessage id="folders.header.companyTitle1" />{" "}
        <b>
          <FormattedMessage id="folders.header.companyTitle2" />
        </b>{" "}
        <p style={{ margin: "0" }}>
          <FormattedMessage id="folders.header.companyTitle3" />
        </p>
        <p style={{ margin: "0" }}>
          <FormattedMessage id="folders.header.companyTitle4" />
        </p>
      </>
    );
  const subtitle =
  main.myType === "STUDIO" ? (
    <>
      <FormattedMessage id="folders.header.subtitleFirstPart" />{" "}
      <b>
        <FormattedMessage id="folders.header.boldSubtitle" />
      </b>{" "}
      <FormattedMessage id="folders.header.subtitleSecondPart" />
    </>
  ) : (
    <p style={{ margin: "0" }}>
      <FormattedMessage id="folders.header.companySubtitle1" />
    </p>
  );

  return (
    <Page
      pageRef={pageRef}
      className="contentStructure transparent"
      marginZero      
      title={main.myType === "STUDIO" ? foldersTitle : foldersTitleCompany}
      subtitle={
        selectedCompanyName?.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
      }
    >
      {foldersDetail.isDownloadingFolder && (
        <PageOverlay
          tip={
            <React.Fragment>
              <FormattedMessage id="folders.downloading1" />
              <br />
              <FormattedMessage id="generic.loading2" />
            </React.Fragment>
          }
        />
      )}
      <PageHeader
        image={`${HeaderFoldersImage}`}
        isFoldersPage={true}
        title={title}
        subtitle={subtitle}
        isPermissionCreateFolders={isPermissionCreateFolders}
        onClick={() => onNewClick()}
      />
      <FoldersList
        confirmDelete={id => confirmDelete(id)}
        isPermissionCreateFolders={isPermissionCreateFolders}        
      />
    </Page>
  );
};

export default FoldersView;
